export function capitalizeWord(string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export function getDecimalSeparator(number) {
  const string = `${number}`;
  if (string.includes(',') && string.includes('.')) return '.';
  if (string.includes('.')) return '.';
  if (string.includes(',')) return ',';
  return null;
}

export function splitOnDecimalSeparator(number) {
  const string = `${number}`;
  if (string.includes(',') && string.includes('.')) return string.split('.');
  if (string.includes('.')) return string.split('.');
  if (string.includes(',')) return string.split(',');
  return [string];
}

export function replaceDecimalSeparator(number) {
  const string = `${number}`;
  if (string.includes(',') && string.includes('.')) return string.replace(/,/g, '');
  if (string.includes(',')) return string.replace(/,/g, '.');
  return string;
}

export function truncateToPrecision(number, maxPrecision) {
  const [integer, decimal] = splitOnDecimalSeparator(number);
  const separator = getDecimalSeparator(number);
  const precision = maxPrecision ?? 2;
  if (separator !== null) {
    return `${integer}${separator}${decimal.substr(0, precision)}`;
  }
  return `${integer}.${''.padStart(maxPrecision, '0')}`;
}
